import {TimelineMax, TweenLite, Sine, Quad} from 'gsap';
const Shortcuts = require('../utils/Shortcuts');


function ConclusionText(selector, refDuration) {

    const constructor = {};
    let _created = false;

    constructor.create = () => {
        if (_created) return constructor.instance.timeline;

        TweenLite.set(selector + ' h3', {opacity: 0, yPercent: 20});
        TweenLite.set(selector + ' li', {opacity: 0, yPercent: 60});
        TweenLite.set(selector + ' p', {opacity: 0, yPercent: 80});
        TweenLite.set(selector, {opacity: 0});

        const obj = {progress: 0, on: false, section: document.querySelector(selector)};
        const tl = new TimelineMax({
            paused: true,
            onUpdate: () => {
                if (obj.progress < 0.01) {
                    if (!obj.on) return;
                    obj.on = false;
                    obj.section.classList.remove('active');
                    TweenLite.to(selector, 0.4, {opacity: 0, ease: Sine.easeInOut});
                    TweenLite.to(selector + ' h4', 0.4, {opacity: 0, yPercent: 20, ease: Sine.easeInOut});
                    TweenLite.to(selector + ' li', 0.4, {opacity: 0, yPercent: 60, ease: Sine.easeInOut});
                    TweenLite.to(selector + ' p', 0.4, {opacity: 0, yPercent: 80, ease: Sine.easeInOut});
                    return;
                }
                if (obj.progress > 1) {
                    if (!obj.on) return;
                    obj.on = false;
                    obj.section.classList.remove('active');
                    TweenLite.to(selector, 0.4, {opacity: 0, ease: Sine.easeInOut});
                    TweenLite.to([selector + ' h4', selector + ' li', selector + ' p'], 0.4, {opacity: 0, yPercent: -10, ease: Sine.easeInOut});
                    return;
                }
                if (obj.on) return;
                obj.section.classList.add('active');
                const n = [...document.querySelectorAll(selector + ' li')].length;
                const tl2 = new TimelineMax();
                tl2.to(selector, 0.4, {opacity: 1, ease: Sine.easeInOut}, 'in');
                tl2.to(selector + ' h4', 0.6, {delay: 0.1, opacity: 1, yPercent: 0, ease: Quad.easeInOut}, 'in');
                tl2.staggerTo(selector + ' li', 0.63, {delay: 0.1, opacity: 1, yPercent: 0, ease: Sine.easeInOut}, 0.1, 'in');
                tl2.to(selector + ' p', 0.63, {delay: 0.1 + 0.1 * n, opacity: 1, yPercent: 0, ease: Quad.easeInOut}, 'in');
                obj.on = true;
            }
        });

        tl.set(obj, {progress: 0}, 'st');
        tl.to(obj, refDuration * 0.3, {progress: 0.5}, 'st');
        tl.to(obj, refDuration * 0.3, {progress: 1}, 'st+=' + refDuration * 0.55);


        constructor.timeline = tl;
        _created = true;
        return tl;
    };

    constructor.destroy = () => {
        if (!_created) return;
        Shortcuts.destroyTimeline(constructor);
        _created = false;
    };

    constructor.startDuration = refDuration * 0.15;
    constructor.totalDuration = refDuration;

    return constructor;
}

module.exports = ConclusionText;


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/timelines/texts/AuthorsText.js